import { h } from "preact";
import { LabelTemplateFields } from "../AgentRegistryLabelPrinterModule";

export function TemplateQuickInfo({
    templateMetadata,
    templateLength,
    fields,
}: {
    templateMetadata: null | { [key: string]: string };
    templateLength?: string;
    fields?: LabelTemplateFields;
}) {
    return templateMetadata ? (
        <div class="template-info-table">
            {templateMetadata["tape-width"]
                ? [<div>Szerokość taśmy</div>, <div>{templateMetadata["tape-width"]}</div>]
                : null}
            {templateLength ? [<div>Długość naklejki</div>, <div>{parseFloat(templateLength) / 14 + 2}mm</div>] : null}
            {templateMetadata["tape-type"]
                ? [<div>Rodzaj taśmy</div>, <div>{templateMetadata["tape-type"]}</div>]
                : null}
            {templateMetadata["gs1-gtin"]
                ? [
                      <div>GTIN</div>,
                      <div>
                          {templateMetadata["gs1-gtin"] === "{field-gtin}"
                              ? fields?.["field-gtin"]
                              : templateMetadata["gs1-gtin"]}
                      </div>,
                  ]
                : null}
            {templateMetadata["gs1-gtin13"]
                ? [
                      <div>GTIN</div>,
                      <div>
                          {templateMetadata["gs1-gtin13"] === "{field-gtin13}"
                              ? fields?.["field-gtin13"]
                              : templateMetadata["gs1-gtin13"]}
                      </div>,
                  ]
                : null}
        </div>
    ) : null;
}
